import React, { useMemo, useState } from "react";
import "../PrathmikVibhag/PrathmikVibhag.css";
import { useNavigate } from "react-router-dom";
import { getNmmsSubjects } from "../../utils/subjectService";
import SectionDivider from "../../common/SectionDivider";

const NMMS = () => {
  const navigate = useNavigate();
  const [loadingStd, setLoadingStd] = useState(null);

  const standards = useMemo(() => [6, 7, 8], []);

  const handleStdClick = async (standardIndex) => {
    try {
      setLoadingStd(standardIndex);
      const subjects = await getNmmsSubjects();

      localStorage.setItem("subjectsData", JSON.stringify(subjects));
      localStorage.setItem(
        "selectedStandard",
        JSON.stringify({ standard_index: standardIndex, standard_title: String(standardIndex) })
      );
      localStorage.setItem("subjectsSource", "nmms");

      navigate("/nmms/subjects");
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingStd(null);
    }
  };

  const colors = ["#4b34fa", "#0C9D26", "#F9B025", "#FD2D2B", "#D020CD"];

  return (
    <div className="pv-container">
      <SectionDivider title="NMMS ના દરેક ધોરણો" />

      <div className="pv-row">
        {standards.map((std, index) => (
          <div
            key={std}
            className="pv-card-new"
            style={{ "--accent": colors[index % colors.length] }}
            onClick={() => handleStdClick(std)}
          >
            <div className="pv-card-top">
              <div className="pv-circle-outer">
                <div className="pv-circle-new">{std}</div>
              </div>
            </div>

            <div className="pv-bottom-band">
              {loadingStd === std ? "Loading..." : `ધોરણ ${std}`}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NMMS;
